import React, {FC} from 'react';

interface IconProps {
  paths: string[];
  /** svg 尺寸/颜色 class，默认适配导航下拉的小图标；产品页能力卡用更大尺寸覆盖，如 "w-6 h-6 text-indigo-600" */
  className?: string;
}

/**
 * heroicons outline 风格的通用图标渲染器：paths 为 SVG path 的 d 属性数组。
 * 提升自原先只在 TopNav/navData.tsx 里定义的 NavIcon（同一份实现，零导航语义）。
 */
const Icon: FC<IconProps> = ({className = 'h-4 w-4', paths}) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
    {paths.map((d) => (
      <path key={d} d={d} strokeLinecap="round" strokeLinejoin="round" />
    ))}
  </svg>
);

export default Icon;
